import invariant from 'tiny-invariant'

import { Currency } from '../currency'
import { NativeCurrency } from '../NativeCurrency'
import { Token, WNATIVE } from '../token'


export class Brise extends NativeCurrency {
  protected constructor(chainId: number) {
    super(chainId, 18, 'BRISE', 'BRISE')
  }

  public get wrapped(): Token {
    const wnative = WNATIVE[this.chainId]
    invariant(!!wnative, 'WRAPPED')
    return wnative
  }

  private static _cache: { [chainId: number]: Brise } = {}

  public static onChain(chainId: number): Brise {
    return this._cache[chainId] ?? (this._cache[chainId] = new Brise(chainId))
  }

  public equals(other: Currency): boolean {
    return other.isNative && other.chainId === this.chainId
  }
}
